var prevStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(63274);
	}
	if (typeof prevStartup === 'function') {
	  return prevStartup();
	} else {
	  console.warn('[Module Federation] prevStartup is not a function, skipping startup execution');
	}
};